<template>
    <section id="careers">
        <b-row>
            <b-col>
                <h2 class="float-right">
                    🚀
                </h2>
                <h3>
                    Join our growing team.
                </h3>
                <h2>
                    Careers.
                </h2>
            </b-col>
        </b-row>
        <b-row>
            <!-- <b-col>
                <sales-internship/>
            </b-col> -->
            <b-col sm="12" class="text-center round-border background-light-grey p-4 small">
                No open vacancies.
                <a href="/contact">
                    Tell us about your dream job.
                </a>
            </b-col>
            <!-- <b-col sm="12" class="text-center small">
                Not for you?
                <b-link
                    class="text-blue"
                    @click="$mailTo('contact@ejournal.app')"
                >
                    Tell us about your dream job.
                </b-link>
            </b-col> -->
        </b-row>
    </section>
</template>
<script>
// import SalesInternship from '@/components/vacancies/SalesInternship.vue'

export default {
    components: {
        // SalesInternship,
    },
}
</script>
